import React from 'react';
import './ProgressBar.css';

/**
 * ProgressBar — Standardized progress indicator
 * 
 * @param {number} value - Progress value (0-100)
 * @param {'sm'|'md'|'lg'} size
 * @param {'green'|'blue'|'orange'|'red'} color
 * @param {boolean} showLabel - Show percentage text
 * @param {string} label - Custom label text (overrides percentage)
 * @param {boolean} animated - Animate the fill
 * @param {boolean} striped - Add stripe pattern
 */
const ProgressBar = ({
  value = 0,
  size = 'md',
  color = 'green',
  showLabel = false,
  label,
  animated = true,
  striped = false,
  className = '',
}) => {
  const clampedValue = Math.min(100, Math.max(0, value));

  const barClasses = [
    'ck-progress',
    `ck-progress--${size}`,
    className,
  ].filter(Boolean).join(' ');

  const fillClasses = [
    'ck-progress-fill',
    `ck-progress-fill--${color}`,
    animated && 'ck-progress-fill--animated',
    striped && 'ck-progress-fill--striped',
  ].filter(Boolean).join(' ');

  return (
    <div className={barClasses}>
      {showLabel && (
        <div className="ck-progress-label">
          <span className="ck-progress-label-text">{label || `${Math.round(clampedValue)}%`}</span>
        </div>
      )}
      <div className="ck-progress-track">
        <div
          className={fillClasses}
          style={{ width: `${clampedValue}%` }}
          role="progressbar"
          aria-valuenow={clampedValue}
          aria-valuemin={0}
          aria-valuemax={100}
        />
      </div>
    </div>
  );
};

export default ProgressBar;
